import { addOrUpdateLinkGroup, addOrUpdateMessageGroup } from '../../apiClient';

import { notifications } from '@mantine/notifications';
import { useEntityQueryUpdate } from '../../../hooks/useEntityQueryUpdate';
import { useMutation } from '@tanstack/react-query';

const useAddLinkGroup = () => {
    const entityUpdater = useEntityQueryUpdate();

    const addLinkGroupMutation = useMutation({
        mutationKey: 'add_link_group',
        mutationFn: (model) => {
            const { id = null, ...rest } = model;
            return addOrUpdateLinkGroup(id, rest);
        },
        onSuccess: (data) => {
            entityUpdater([['link_groups'], ['link_group', data.id]], data);
            notifications.show({
                title: 'Success',
                message: 'Successfully created link group',
                color: 'green',
            });
        },
        onError: (error) => {
            notifications.show({
                title: 'Error',
                message: error.message,
                color: 'red',
            });
        },
    });
    return addLinkGroupMutation;
};
export default useAddLinkGroup;
